// ===== Packages =====

import {
    collection,
    getFirestore,
    limit,
    onSnapshot,
    orderBy,
    query,
    Unsubscribe,
    where,
}                           from 'firebase/firestore';

// ===== Interfaces =====

import {
    IPostUpdateEventItem,
}                           from '../interfaces';

// ===== Enums =====

import {
    FIRESTORE_COLLECTION,
    POST_CONTENT_SCOPE,
}                           from '../enums';

const subscribeToLatestPostUpdateEvent = ({
    test,
    postId,
    scope,
    scopeId,
    onNext,
}: {
    test: boolean,
    postId: string,
    scope: POST_CONTENT_SCOPE,
    scopeId: string,
    onNext: (postUpdateEvent: IPostUpdateEventItem | null) => void,
}): Unsubscribe => {
    const firestore = getFirestore();
    const postUpdateEventsCollection = test
        ? FIRESTORE_COLLECTION.stagingPostUpdateEvents
        : FIRESTORE_COLLECTION.postUpdateEvents;

    return onSnapshot(
        query(
            collection(firestore, postUpdateEventsCollection),
            where('postId', '==', postId),
            where('scope', '==', scope),
            where('scopeId', '==', scopeId),
            orderBy('updatedAt', 'desc'),
            limit(1),
        ),
        (snapshot) => {
            const [docSnapshot] = snapshot.docs;
            if (!docSnapshot) {
                onNext(null);
                return;
            }
            onNext(docSnapshot.data() as IPostUpdateEventItem);
        },
        () => onNext(null),
    );
};

export default subscribeToLatestPostUpdateEvent;
